import {
  Drawer,
  Dialog,
  DialogContent,
  Grid,
  Icon,
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
  TextField,
  Typography,
} from "@mui/material";

import { useEffect } from "react";

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "+", "0"];

function DialPad({ open, onClose, onSubmit, phoneNumber, setPhoneNumber }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setPhoneNumber("");
  }, [open]);

  function handleKeyPress(key) {
    setPhoneNumber((prev) => prev + key);
  }

  function handleDelete() {
    setPhoneNumber((prev) => prev.slice(0, -1));
  }

  function handleSubmit() {
    if (!phoneNumber) return;

    onSubmit(phoneNumber);
    setPhoneNumber("");
  }

  const content = (
    <Box p={3}>
      <Box>&nbsp;</Box>
      <Box>
        <TextField
          fullWidth
          value={phoneNumber || ""}
          placeholder="Enter phone number"
          onChange={(e) => {
            // Allows keyboard typing updates to flow into the state engine properly
            setPhoneNumber(e.target.value);
          }}
          onKeyDown={(e) => {
            // 1. Allow structural system shortcuts (Ctrl/Cmd + V, C, A, X)
            const isSystemShortcut =
              (e.ctrlKey || e.metaKey) &&
              ["v", "c", "a", "x"].includes(e.key.toLowerCase());

            // 2. Allow navigation, clearing, and structural tracking keys
            const isUtilityKey = [
              "Backspace",
              "Delete",
              "ArrowLeft",
              "ArrowRight",
              "Tab",
              "Home",
              "End",
              "Enter",
            ].includes(e.key);

            // 3. Match pure digits (0-9) and the "+" sign explicitly
            const isValidInputChar = /^[0-9+]$/.test(e.key);

            // If it's none of the above, halt the event immediately
            if (!isSystemShortcut && !isUtilityKey && !isValidInputChar) {
              e.preventDefault();
            }
          }}
          onPaste={(e) => {
            e.preventDefault();
            const pasted = e.clipboardData
              .getData("text")
              .replace(/[^0-9*#+]/g, "");
            setPhoneNumber(pasted);
          }}
          inputProps={{
            style: {
              textAlign: "center",
              fontSize: "28px",
              letterSpacing: "2px",
            },
          }}
        />
      </Box>
      <Box>&nbsp;</Box>
      <Box mt={4}>
        <Grid container spacing={2}>
          {keys.map((key) => (
            <Grid item xs={4} md={4} lg={4} key={key}>
              <IconButton
                onClick={() => handleKeyPress(key)}
                sx={{
                  width: "100%",
                  height: 75,
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: "10%",
                  fontSize: 28,
                  fontWeight: "bold",
                }}
              >
                {key}
              </IconButton>
            </Grid>
          ))}
          <Grid item xs={4} md={4} lg={4}>
            <IconButton
              onClick={handleDelete}
              sx={{
                width: "100%",
                height: 75,
                border: "1px solid",
                borderColor: "grey.300",
                borderRadius: "10%",
                fontSize: 28,
                fontWeight: "bold",
              }}
            >
              <Icon>backspace</Icon>
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Box>&nbsp;</Box>
      <Grid mt={5} container spacing={3}>
        <Grid item xs={6} md={6} lg={6} align="center">
          <IconButton
            onClick={handleSubmit}
            sx={{
              width: 75,
              height: 75,
              backgroundColor: "success.main",
              color: "#fff",
              "&:hover": {
                backgroundColor: "success.dark",
              },
            }}
          >
            <Icon>call</Icon>
          </IconButton>
        </Grid>
        <Grid item xs={6} md={6} lg={6} align="center">
          <IconButton
            onClick={onClose}
            sx={{
              width: 75,
              height: 75,
              backgroundColor: "error.main",
              color: "#fff",
              "&:hover": {
                backgroundColor: "error.dark",
              },
              border: "1px solid #e0e0e0",
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      sx={{
        "& .MuiDrawer-paper": {
          position: "fixed",
          top: "0 !important",
          right: "0 !important",
          margin: "0 !important",
          width: 420,
          maxWidth: "100vw",
          height: "100vh",
          borderRadius: 0,
        },
      }}
    >
      {content}
    </Drawer>
  );
}

export default DialPad;
